import React from "react";
import { StyleSheet, Pressable, Dimensions } from "react-native";
import { BlurView } from "expo-blur";
import Animated, {
  FadeIn,
  FadeOut,
  SlideInDown,
  SlideOutDown,
} from "react-native-reanimated";

import { Colors } from "../globalStyles/ColorConfig";
import dimensions from "../globalStyles/dimensions";

interface CustomModalComponentProps {
  width: any;
  height: any;
  toggleModal: any;
  children: React.ReactNode;
  zIndex?: any;
}

export default function CustomModalComponent({
  width,
  height,
  toggleModal,
  children,
  zIndex,
}: CustomModalComponentProps) {
  const AnimatedPressable = Animated.createAnimatedComponent(Pressable);

  return (
    <>
      <AnimatedPressable
        style={{
          backgroundColor: "transparent",
          height: dimensions.windowHeight,
          position: "absolute",
          width: dimensions.windowWidth,
        }}
        entering={FadeIn}
        exiting={FadeOut}
        onPress={toggleModal}
      >
        <BlurView
          style={{ height: Dimensions.get("window").height, width: "100%" }}
          tint="dark"
          intensity={100}
        />
      </AnimatedPressable>
      <Animated.View
        style={{
          position: "absolute",
          bottom: 0,
          width: width,
          height: height,
          backgroundColor: Colors.white000,
          zIndex: zIndex,
        }}
        entering={SlideInDown.springify().damping(15)}
        exiting={SlideOutDown}
      >
        {children}
      </Animated.View>
    </>
  );
}

const styles = StyleSheet.create({
  modalBackground: {
    flex: 1,
  },
  ModalPrimaryButton: {
    backgroundColor: Colors.darkGreen,
  },
  ModalPrimaryButtonText: {
    color: "#fff",
    fontSize: 16,
  },
  ModalButton: {
    borderWidth: 0.5,
    borderColor: "#000",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "50%",
    paddingVertical: 15,
  },
  ModalButtonWrap: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 20,
    width: "100%",
  },
  modalContainer: {
    justifyContent: "center",
    width: "100%",
    textAlign: "center",
    position: "absolute",
    top: "35%",
    alignItems: "center",
  },
  backdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "transparent",
  },
});
